export default __webpack_public_path__ + "static/media/playgroundimage.ecb7e44b.png";